import type { Router } from 'vue-router'
import { usePermissionStoreWithOut } from '@/store-pinia/modules/permission'

export function createParamsGuard(router: Router) {
  const permissionStore = usePermissionStoreWithOut()
  router.beforeEach(async (to, _, next) => {
    if (!to.name) {
      next()
      return
    }

    if (!permissionStore.getIsDynamicAddedRoute) {
      next()
      return
    }

    const foundToRoute = router.getRoutes().find((route) => route.path === to.path)
    if (foundToRoute) {
      const matchRes = (foundToRoute.meta.frameSrc || '').match(/[^?]+/)
      const frameSrc = matchRes ? matchRes[0] : ''
      const toQuery = new URLSearchParams(to.query as Record<string, any>).toString()
      foundToRoute.meta.frameSrc = toQuery ? `${frameSrc}?${toQuery}` : frameSrc
    }

    next()
  })
}
